import React from 'react';
import { useIntl } from 'react-intl';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { default as SidebarPortal } from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import SubscribeSchema from './SubscribeSchema';
import config from '@plone/volto/registry';
import SubscribeView from './SubscribeView';

export function getSubscribeImageURL(image) {
  if (image) {
    if (isInternalURL(image['@id'])) {
      return `${image['@id']}/@@images/image`;
    } else {
      return image['@id'];
    }
  }
}

const SubscribeEdit = (props) => {
  const {
    data,
    // isEditMode,
    selected,
    onChangeBlock,
    block,
    // id,
    // className,
    // placeholder,
  } = props;
  const intl = useIntl();

  return (
    <>
      <SubscribeView {...props} isEditMode={true} />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          title="Subscribe Block"
          schema={SubscribeSchema(config, intl)}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default SubscribeEdit;
